"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_TERMS_AND_CONDITIONS = exports.GET_TERMS_AND_CONDITIONS = exports.RENEW_IDOLOGY_URL = exports.VERIFY_STATUS = exports.VERIFY_PROFILE = exports.RESET_ERROR = exports.GET_LOYALTY_SUMMARY = exports.MARK_TICKET_CHECKER_INSTRUCTIONS_AS_VIEWED = exports.CHANGE_EMAIL_ADDRESS = exports.CHECK_PASSWORD = exports.GET_INSTAGRAM_ACCESS_TOKEN = exports.GET_TWITTER_REQUEST_TOKEN = exports.GET_TWITTER_OAUTH_TOKEN = exports.INITIAL_SCREEN_STATE = exports.SOCIAL_CONNECT = exports.RESET = exports.UPDATE_PROFILE = exports.GET_PROFILE = exports.AddressType = exports.PhoneType = void 0;
const forms_1 = require("../forms");
const INITIAL_SCREEN_STATE = {
    firstName: '',
    lastName: '',
    email: '',
    dateOfBirth: null,
    gender: '',
    address: new forms_1.Address(),
    phone: '',
    firstNameError: false,
    lastNameError: false,
    emailError: false,
    dateOfBirthError: false,
    addressError: false,
    isDirty: false,
    activityPoints: 0,
    displayModal: false,
    focusedField: ''
};
exports.INITIAL_SCREEN_STATE = INITIAL_SCREEN_STATE;
var PhoneType;
(function (PhoneType) {
    PhoneType[PhoneType["MOBILE"] = 1] = "MOBILE";
    PhoneType[PhoneType["HOME"] = 2] = "HOME";
    PhoneType[PhoneType["WORK"] = 3] = "WORK";
    PhoneType[PhoneType["BILLING"] = 4] = "BILLING";
})(PhoneType || (exports.PhoneType = PhoneType = {}));
var AddressType;
(function (AddressType) {
    AddressType[AddressType["HOME"] = 1] = "HOME";
    AddressType[AddressType["WORK"] = 2] = "WORK";
    AddressType[AddressType["BILLING"] = 3] = "BILLING";
})(AddressType || (exports.AddressType = AddressType = {}));
const GET_PROFILE = 'profile/GET_PROFILE';
exports.GET_PROFILE = GET_PROFILE;
const UPDATE_PROFILE = 'profile/UPDATE_PROFILE';
exports.UPDATE_PROFILE = UPDATE_PROFILE;
const RESET = 'profile/RESET';
exports.RESET = RESET;
const SOCIAL_CONNECT = 'profile/SOCIAL_CONNECT';
exports.SOCIAL_CONNECT = SOCIAL_CONNECT;
const GET_TWITTER_REQUEST_TOKEN = 'profile/GET_TWITTER_REQUEST_TOKEN';
exports.GET_TWITTER_REQUEST_TOKEN = GET_TWITTER_REQUEST_TOKEN;
const GET_TWITTER_OAUTH_TOKEN = 'profile/GET_TWITTER_OAUTH_TOKEN';
exports.GET_TWITTER_OAUTH_TOKEN = GET_TWITTER_OAUTH_TOKEN;
const GET_INSTAGRAM_ACCESS_TOKEN = 'profile/GET_INSTAGRAM_ACCESS_TOKEN';
exports.GET_INSTAGRAM_ACCESS_TOKEN = GET_INSTAGRAM_ACCESS_TOKEN;
const CHECK_PASSWORD = 'profile/CHECK_PASSWORD';
exports.CHECK_PASSWORD = CHECK_PASSWORD;
const CHANGE_EMAIL_ADDRESS = 'profile/CHANGE_EMAIL_ADDRESS';
exports.CHANGE_EMAIL_ADDRESS = CHANGE_EMAIL_ADDRESS;
const MARK_TICKET_CHECKER_INSTRUCTIONS_AS_VIEWED = 'profile/MARK_TICKET_CHECKER_INSTRUCTIONS_AS_VIEWED';
exports.MARK_TICKET_CHECKER_INSTRUCTIONS_AS_VIEWED = MARK_TICKET_CHECKER_INSTRUCTIONS_AS_VIEWED;
const GET_LOYALTY_SUMMARY = 'profile/GET_LOYALTY_SUMMARY';
exports.GET_LOYALTY_SUMMARY = GET_LOYALTY_SUMMARY;
const RESET_ERROR = 'profile/RESET_ERROR';
exports.RESET_ERROR = RESET_ERROR;
const VERIFY_PROFILE = 'profile/VERIFY_PROFILE';
exports.VERIFY_PROFILE = VERIFY_PROFILE;
const VERIFY_STATUS = 'profile/VERIFY_STATUS';
exports.VERIFY_STATUS = VERIFY_STATUS;
const RENEW_IDOLOGY_URL = 'profile/RENEW_IDOLOGY_URL';
exports.RENEW_IDOLOGY_URL = RENEW_IDOLOGY_URL;
const GET_TERMS_AND_CONDITIONS = 'profile/GET_TERMS_AND_CONDITIONS';
exports.GET_TERMS_AND_CONDITIONS = GET_TERMS_AND_CONDITIONS;
const UPDATE_TERMS_AND_CONDITIONS = 'profile/UPDATE_TERMS_AND_CONDITIONS';
exports.UPDATE_TERMS_AND_CONDITIONS = UPDATE_TERMS_AND_CONDITIONS;
//# sourceMappingURL=types.js.map